/* eslint-disable no-param-reassign */
import produce from 'immer';
import getInitialState from './getInitialState';
var markerGenesLoading = produce(function (draft, action) {
  var _action$payload = action.payload,
    ETag = _action$payload.ETag,
    requestSignature = _action$payload.requestSignature;
  draft.markers.loading = true;
  draft.markers.error = false;
  draft.markers.requestSignature = requestSignature;
  if (ETag) {
    draft.expression.downsampled.ETag = ETag;
  }
}, getInitialState());
export default markerGenesLoading;